module.exports = __webpack_public_path__ + "static/assets/2258ea6dfe9ad15440ca55aca291698d.svg";